import config from "./config";
import { msalConfigs, funcAppScopes, graphScope, graphConfig } from "./auth-config";

// Le contrôle d'accès réel vit dans service-smart-implant (roles/me côté IEP_Back) :
// le rôle plateforme que @VinciDiane/core exige pour laisser passer ses routes est
// ignoré, on lui renvoie directement les rôles attendus, sans backend.
// "Dev" en plus : ProtectedRoute (core) a SON PROPRE blocage de maintenance globale
// interne (userRoles.includes("Dev") outrepasse), indépendant et non pilotable de
// notre gate dans App.jsx/AppContent (bypass admin, panneau d'édition...). Sans ça,
// même un admin qui a cliqué "Accéder à la plateforme quand même" retombe sur le
// texte générique de core dès qu'une route matche. Notre gate reste la seule
// source de vérité pour la maintenance : celui de core est neutralisé pour tout
// le monde plutôt que de laisser deux blocages à moitié pilotables coexister.
const IGNORED_ROLES = { roles: ["Plateforme.Service36", "baseauth", "Dev"], permissions: [] };
// Catalogue multi-service (@VinciDiane/core en a besoin en interne) : IEP est un
// service unique, pas de backend à interroger.
const EMPTY_TOOLS = { tools: [] };

const platformConfig = {
  isDebug: config.isDebug,
  isLocal: config.isLocal,
  apiErrorReportUri: config.apiErrorReportUri,
  apiCredentialsUri: config.apiCredentialsUri,
  apiAccessUri: config.apiAccessUri,
  apiGetRolesUri: `data:application/json,${encodeURIComponent(JSON.stringify(IGNORED_ROLES))}`,
  apiToolsUri: `data:application/json,${encodeURIComponent(JSON.stringify(EMPTY_TOOLS))}`,
  apiGetPlatformStatusUri: config.apiGetPlatformStatusUri,
  apiSetPlatformStatusUri: config.apiSetPlatformStatusUri,
  auth: { msalConfigs, funcAppScopes, graphScope, graphConfig },
};

export default platformConfig;
